import React, { Fragment } from 'react';
import styled from 'styled-components';

import { Col, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: 24px;
`;

const FlexText = styled(Text)`
  flex: 1;
`;

const RowGap = styled(Row)`
  gap: 8px;
`;

const MAP = {
  direct_share_text: 'Direct Shareable Text',
  indirect_share_text: 'Indirect Shareable Text',
  exclusive_section_how_it_works: 'How It Works of Exculsive Section',
  how_it_works_text: 'How it Works',
};

const ReferralTemplate = ({ template }) => {
  return (
    <>
      {Object.entries(template)?.map(([key, value]) => {
        return (
          <Column key={key}>
            {typeof value === 'string' && (
              <Fragment key={key}>
                <Text variant="eyebrow2">{MAP[key] || key}</Text>
                <Text variant="h6">{MAP[value] || value}</Text>
              </Fragment>
            )}
            {Array.isArray(value) && (
              <Fragment key={key}>
                <Text variant="eyebrow2">{MAP[key] || key}</Text>
                {value?.map(el => {
                  const { text } = el || {};
                  if (typeof el === 'string') {
                    return (
                      <RowGap key={el} gap={2}>
                        <Text variant="h6">&#x2022;</Text>
                        <FlexText variant="h6">{el.replaceAll('{bold}', '')}</FlexText>
                      </RowGap>
                    );
                  }
                  if (typeof el === 'object') {
                    return (
                      <RowGap key={text} gap={2}>
                        <Text variant="h6"> &#x2022;</Text>
                        <FlexText variant="h6">{text}</FlexText>
                      </RowGap>
                    );
                  }
                  return null;
                })}
              </Fragment>
            )}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralTemplate;
